const initialState = {
  activeTab: "",
};

export const tabsNavbarReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CHANGE_TAB":
      return { activeTab: action.payload };
    default:
      return state;
  }
};
